import { render } from "./annul.vue?vue&type=template&id=6bae7587"
import script from "./annul.vue?vue&type=script&lang=js"
export * from "./annul.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__